import type { SVGProps } from "react";
const GazCodesLogo4Filled = (props: SVGProps<SVGSVGElement>) => (
  <>
    <style>
      {`
      :root {
        --fg: currentColor;
        --bg: black;
      }
    `}
    </style>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1em"
      height="1em"
      viewBox="0 0 1400 1400"
      aria-hidden="true"
      {...props}
    >
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M700.000,0.000 C1086.599,0.000 1399.1000,313.401 1399.1000,700.000 C1399.1000,1086.599 1086.599,1399.1000 700.000,1399.1000 C313.401,1399.1000 0.000,1086.599 0.000,700.000 C0.000,313.401 313.401,0.000 700.000,0.000 Z"
        style={{ fill: "var(--bg)", opacity: 0.2 }}
      />
      <path
        fillRule="evenodd"
        fill="white"
        d="M783.913,301.136 L700.500,149.1000 L237.1000,988.000 L869.250,988.000 L794.250,856.672 L481.750,856.672 L783.913,301.136 ZM988.1000,668.810 L1162.1000,988.000 L988.1000,988.000 L814.1000,668.810 L988.1000,668.810 Z"
        style={{ fill: "var(--fg)" }}
      />
    </svg>
  </>
);
export default GazCodesLogo4Filled;
